import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SessionService } from '@domain/application/observable-services/session.service';
import { AssetLink } from '@utils/helpers/asset-cpm-link';

@Component({
  selector: 'ba-view-lock-otp',
  templateUrl: './view-lock-otp.component.html',
  styleUrls: ['./view-lock-otp.component.scss']
})
export class ViewLockOtpComponent extends AssetLink() implements OnInit {

  isLoading = false;
  firstName: string = '';
  @Output() exitFlowCreateAccount = new EventEmitter<void>();

  constructor(private readonly sessionService: SessionService) {
    super();
  }

  ngOnInit(): void {
    const { firstName } = this.sessionService.getCommonInfoValue;
    this.firstName = firstName;
  }
}